import React from "react"
// import { Icon } from "@iconify/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  goToHome() {
    window.location.replace('/')
  }

  componentDidCatch(error, info) {
    // Update state so the next render shows the fallback UI
    this.setState({ hasError: true });

    // Optionally, log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, info);
}


  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    console.log({ error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="grid place-items-center h-screen w-screen">
          <div className="flex flex-col items-center space-y-4 text-center">
            <div>
              <h2 className="text-2xl font-semibold">Something went wrong</h2>
              <p>Please bear with us as we fix it.</p>
            </div>
            <button icon="ic:round-arrow-back" onClick={this.goToHome} size="small">
              <span>Return to Homepage</span>
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary